import { DEFAULT_PAGE_DIMENSION } from '../../utils/constants';
import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  loading: false,
  searching: false,
  ignoreKeyCodeEvent: false,
  objectName: '',
  objectId: '',
  activeType: null,
  commonSettings: {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    angle: 0,
    scaleX: 1,
    scaleY: 1,
  },
  componentSettings: null,
  zoomRatio: 100,
  canvasDrawingMode: false,
  isDrawingToolOpen: false,
  isTrashOpen: false,
  drawingObj: null,
  handleGroupDrawing: [],
  layerAction: null,
  isVisualListOpen: false,
  page: DEFAULT_PAGE_DIMENSION,
  isUseHandTool: false,
};

const boardSlice = createSlice({
  name: 'board',
  initialState: INITIAL_STATE,
  reducers: {
    setObjectName: (state, action) => {
      state.objectName = action.payload;
    },
    setObjectId: (state, action) => {
      state.objectId = action.payload;
    },
    updateCommonSettings: (state, action) => {
      state.commonSettings = action.payload;
    },
    setActiveType: (state, action) => {
      state.activeType = action.payload;
    },
    updateComponentSettings: (state, action) => {
      state.componentSettings = action.payload;
    },
    updateZoomRatio: (state, action) => {
      state.zoomRatio = action.payload;
    },
    setCanvasDrawingMode: (state, action) => {
      state.canvasDrawingMode = action.payload;
    },
    setDrawingToolOpen: (state, action) => {
      state.isDrawingToolOpen = action.payload;
    },
    setTrashOpen: (state, action) => {
      state.isTrashOpen = action.payload;
    },
    setDrawingValues: (state, action) => {
      state.drawingObj = action.payload;
    },
    setHandleGroupDrawing: (state, action) => {
      state.handleGroupDrawing = action.payload;
    },
    updatePageSize: (state, action) => {
      state.page = action.payload;
    },
    setLayerAction: (state, action) => {
      state.layerAction = action.payload;
    },
    setSearchComponent: (state, action) => {
      state.searching = action.payload;
    },
    setVisualListOpen: (state, action) => {
      state.isVisualListOpen = action.payload;
    },
    setIgnoreKeyCodeEvent: (state, action) => {
      state.ignoreKeyCodeEvent = action.payload;
    },
    setHandToolMode: (state, action) => {
      state.isUseHandTool = action.payload;
    },
  },
});
export default boardSlice.reducer;
export const {
  setObjectName,
  setObjectId,
  updateCommonSettings,
  setActiveType,
  updateComponentSettings,
  updateZoomRatio,
  setCanvasDrawingMode,
  setDrawingToolOpen,
  setTrashOpen,
  setDrawingValues,
  setHandleGroupDrawing,
  updatePageSize,
  setLayerAction,
  setSearchComponent,
  setVisualListOpen,
  setIgnoreKeyCodeEvent,
  setHandToolMode,
} = boardSlice.actions;
export const boardSelector = (state) => state.board;
